(function($) {
    
    // Video Block CTA Click
    $('#play-full-video').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.full-photo').find('.play').hide();
        $(this).closest('.full-photo').find('.photo').hide();
        $(this).closest('.full-photo').find('.video').show();
    });

    // team member email form modal
    /*
    $('.member-contact').on('click', function (e) {
        e.preventDefault();

        
        var memberName = $(this).data('name');
        var memberEmail = $(this).data('email');
        //console.log(memberEmail);
        //$(".team_modal .member-name-place").text( memberName );
        //$(".team_modal .modal-body .gfield--type-hidden input").attr('value', memberEmail);
        $('#member-form-area').toggle();
        $("#member-form-area .gfield--type-hidden input").attr('value', memberEmail);
        
    });
    */

    // check for team email form error 
    /*
    if ($('#gform_wrapper_1').hasClass('gform_validation_error')) {
      // There are validation errors
      console.log('Gravity Forms has errors.');
      $('#member-form-area').show();
    } 
    else {
      // No validation errors
      //$('#member-form-area').show();
      console.log('Gravity Forms is valid.');
    }
    */

    $('.play-block-video').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.photo-column-block').find('.content-area').hide();
        $(this).closest('.photo-column-block').find('.photo-area').hide();
        //$(this).closest('.content-block-wrapper').find('figure').hide();
        $(this).closest('.photo-column-block').find('.video').show();
    });

    $("#podcast-other").on('change', function () {
        //window.location.href = $(this).val();
        window.open($(this).val(), '_blank', 'toolbar=0,location=0,menubar=0');
    });

    $('.accordion').each(function() {

        let accordionItems = $(this).find('.accordion-item'),
            accordionHeaders = $(this).find('.accordion-item-header'),
            accordionContents = $(this).find('.accordion-item-content');

        accordionHeaders.on('click', function() {

            let accordionItem = $(this).closest('.accordion-item'),
                accordionContent = accordionItem.find('.accordion-item-content');

            if (accordionItem.hasClass('active')) {
                accordionItem.removeClass('active');
                accordionContent.slideUp();
            } else {
                accordionItems.removeClass('active');
                accordionContents.slideUp();
                accordionItem.addClass('active');
                accordionContent.slideDown();
            }

        });

    });

    $('#carouselHero2').slick({
        accessibility: false,
        arrows: true,
        prevArrow: '<button class="slick-prev"><span class="sr-only">Previous</span></button>',
        nextArrow: '<button class="slick-next"><span class="sr-only">Next</span></button>',
        asNavFor: '.slider-nav-2',
        fade: true,
        slide: '.carousel-item',
        slidesToScroll: 1,
        slidesToShow: 1,
        infinite: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                }
            }
        ]
    });
    $('.slider-nav-2').slick({
        accessibility: false,
        prevArrow: '<button class="slick-prev"><span class="sr-only">Previous</span></button>',
        nextArrow: '<button class="slick-next"><span class="sr-only">Next</span></button>',
        asNavFor: '#carouselHero2',
        dots: false,
        focusOnSelect: true,
        slidesToScroll: 1,
        slidesToShow: 5,
        infinite: true,
        centerMode: false,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    asNavFor: '#carouselHero2',
                    slidesToScroll: 1,
                    slidesToShow: 5,

                }
            },
            {
                breakpoint: 1200,
                settings: {
                    asNavFor: '#carouselHero2',
                    slidesToScroll: 1,
                    slidesToShow: 5,

                }
            },
            {
                breakpoint: 768,
                settings: {
                    asNavFor: '#carouselHero2',
                    slidesToScroll: 1,
                    slidesToShow: 2,
                    arrows: false,
                }
            },
            {
                breakpoint: 500,
                settings: {
                    asNavFor: '#carouselHero2',
                    slidesToScroll: 1,
                    slidesToShow: 1,
                }
            }
        ]
    });

    $('#topics-link').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('open');
        $('#media-content').hide();
        $('#topics-content').slideToggle();
    });

    $('.location-title').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('active')
        $(this).closest('.container').find('.locations-table').toggle();
        //$(this).closest('.row').find('.video').show();
    });

    $('.footer-nav').click(function(e){
        e.preventDefault();

        if ($(window).width() < 992) {
            $(this).closest('.footer-menu').find('.menu').slideToggle();
        }
    });

    var menu = $('.primary-header');
    if(menu.length) {
        var origOffsetY = menu.offset().top;
    }
    //console.log(origOffsetY);

    function scroll() {
        //console.log($(window).scrollTop());

        if ($(window).scrollTop() >= origOffsetY) {
            $('.primary-header').addClass('sticky');
            //$('.content').addClass('menu-padding');
        } else {
            $('.primary-header').removeClass('sticky');
            //$('.content').removeClass('menu-padding');
        }


    }

    document.onscroll = scroll;


    // speedbump check - all external links should see the speedbump except those specifically removed
    $('a').click(function(e){

        var currentHost = window.location.host;
        var linkHost = this.hostname;
        //alert( currentHost + " = " + linkHost);

        // if the link is external, show the speedbump
        if(linkHost !== currentHost) {

            // manual speedbump bypass
            if ( $(this).hasClass( "no-speedbump" ) ) {
                e.preventDefault();
                window.open( $(this).attr('href'), '_blank');
            }
            else {
                e.preventDefault();
                var answer = confirm("You are now leaving our website. The privacy policy of the site to which you are going may differ from our privacy policy. Click OK to continue or Cancel to remain on our site.");

                if (answer){
                    window.open( $(this).attr('href'), '_blank');
                }
            }
        }
        else if( $(this).hasClass( "external" ) ) {
            e.preventDefault();
            var answer = confirm("You are now leaving our website. The privacy policy of the site to which you are going may differ from our privacy policy. Click OK to continue or Cancel to remain on our site.");

            if (answer){
                window.open( $(this).attr('href'), '_blank');
            }
        }

    });

    $('.form-tab').on('click', function (e) {
        e.preventDefault();
        //$('.podcast-season').hide();
        //$('.podcast-info').hide();

        $('#podcast-form').toggle();
    });


    // Reserve pages

    $('a[href="#reserve-contact"]').on('click', function(e) {
        e.preventDefault();
        $('#modalContactReserve').modal('show');
    });

    let menuOpen = $('.reserve-mobile-toggle');
    let menuClose = $('.reserve-close-mobile-nav');
    let menuReserve = $('.reserve-mobile-nav');

    menuOpen.on('click', function() {
        menuReserve.fadeIn();
    });

    menuClose.on('click', function() {
        menuReserve.fadeOut();
    });

    let reserveMenu = $('.site-header-reserve');

    $(window).scroll(function() {
        if ($(window).scrollTop() > 50) {
            reserveMenu.addClass('scrolled');
        } else {
            reserveMenu.removeClass('scrolled');
        }
    });


}(jQuery));